function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sortable from 'sortablejs';
import common from './components/customCommon';
import { getFormListApi, formCateSaveApi, formCateDeleteApi, formCatePutSaveApi, formCatePutApi, getDictListApi, formCateSaveDataApi, formCateMoveApi } from '@/api/form';
export default {
  name: '',
  components: {
    oaDialog: function oaDialog() {
      return import('@/components/form-common/dialog-form');
    }
  },
  data: function data() {
    return {
      // 弹窗样式
      loadingBox: false,
      loading: false,
      fromData: {
        title: '新增分组',
        type: 'add',
        width: '500px',
        labelWidth: '80px',
        btnText: '确定'
      },
      formConfig: [],
      formDataInit: {},
      label: '1',
      formRules: {
        title: [{
          required: true,
          message: '请输入分组名称',
          trigger: 'blur'
        }]
      },
      id: '',
      // 表单rowid
      cate_id: '',
      // 分组id
      move: false,
      //判断当前是移动分组/新增分组
      dataList: [],
      // 自定义表单列表
      typeOptions: common.typeOptions,
      // 字段类型选项
      typeDisabled: common.typeDisabled,
      // 字段类型选项
      dictList: [],
      // 字典选项
      groupList: [],
      // 分组列表
      activeName: '1',
      contractList: common.contractList,
      maxDisabledList: common.maxDisabledList
    };
  },
  mounted: function mounted() {
    this.getDictList();
    this.getList();
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('user/REMOVE_FORMDIC', []);
  },
  methods: {
    // 组合新增分组表单内容
    addGroupingData: function addGroupingData() {
      this.formConfig = [{
        key: 'title',
        label: '分组名称:',
        type: 'input',
        maxlength: 20,
        placeholder: '请输入分组名称'
      }, {
        key: 'sort',
        label: '排序:',
        type: 'inputNumber',
        placeholder: '请输入排序，数字越大越靠前'
      }];
      this.formDataInit = {
        title: '',
        sort: ''
      };
    },
    // 获取字典列表
    getDictList: function getDictList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                page: 1,
                limit: ''
              };
              _context.next = 3;
              return getDictListApi(data);
            case 3:
              result = _context.sent;
              _this.dictList = result.data.list.filter(function (item) {
                return item.status == 1;
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取默认值的列表
    changeCascader: function changeCascader(val, index1, index) {
      var arr = val.value.map(function (str) {
        return parseInt(str);
      });
      this.dataList[index1].data[index].value = arr;
    },
    // 获取下拉框的默认值
    getDictData: function getDictData(dict_ident, index1, index) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                level: '',
                types: dict_ident
              };
              _this2.$store.dispatch('user/getDictList', data).then(function (res) {
                setTimeout(function () {
                  var result = res.find(function (item) {
                    return item.dict_ident == dict_ident;
                  });
                  _this2.dataList[index1].data[index].optionItems = result.list;
                }, 300);
              }).catch(function (err) {
                console.log(err, 'err');
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 获取分组集合
    getGroupList: function getGroupList() {
      var _this3 = this;
      this.groupList = [];
      if (this.dataList.length > 0) {
        this.dataList.map(function (item) {
          var data = {
            id: item.id,
            name: item.title
          };
          _this3.groupList.push(data);
        });
      }
    },
    // 获取表单分组列表
    getList: function getList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.loadingBox = true;
              _context3.next = 3;
              return getFormListApi({
                types: _this4.activeName
              });
            case 3:
              result = _context3.sent;
              _context3.next = 6;
              return result.data.forEach(function (item, index) {
                item.enable_delete = 1;
                item.data.forEach(function (val, index1) {
                  val.optionItems = [];
                  if (val.enable_delete == 0) {
                    result.data[index].enable_delete = 0;
                  }
                  if (val.dict_type_id == 0) {
                    val.dict_type_id = '';
                  }
                  if (val.type == 'date' && typeof val.max !== 'string' && typeof val.min !== 'string') {
                    val.max = '';
                    val.min = '';
                  }
                  if (!_this4.getTypes(val.type, 'radio', 'checked', 'select')) {
                    var data = {
                      level: '',
                      types: val.dict_ident
                    };
                    if (val.dict_ident) {
                      _this4.$store.dispatch('user/getDictList', data).then(function (res) {
                        setTimeout(function () {
                          var resultDict = res.find(function (item) {
                            return item.dict_ident == val.dict_ident;
                          });
                          if (resultDict.list) {
                            val.optionItems = resultDict.list;
                          }
                        }, 300);
                      });
                    }
                  }
                });
              });
            case 6:
              _this4.dataList = result.data;
              _this4.getGroupList();
              _this4.loadingBox = false;
              setTimeout(function () {
                _this4.rowDrop();
              }, 300);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 移动分组
    moveFn: function moveFn(row) {
      this.id = row.id;
      this.move = true;
      this.fromData.title = '移动分组';
      this.fromData.type = 'add';
      this.formConfig = [{
        key: 'itemId',
        label: '分组名称:',
        type: 'select',
        maxlength: 20,
        placeholder: '请选择分组',
        options: this.groupList
      }];
      this.formDataInit = {
        itemId: ''
      };
      this.$refs.oaDialog.openBox();
    },
    // 编辑分组
    editCate: function editCate(row) {
      this.addGroupingData();
      this.cate_id = row.id;
      this.fromData.title = '编辑分组';
      this.fromData.type = 'edit';
      this.formDataInit.title = row.title;
      this.formDataInit.sort = row.sort;
      this.$refs.oaDialog.openBox();
    },
    // 删除
    deleteFn: function deleteFn(row, index) {
      var _this5 = this;
      this.$modalSure('你确定要删除这条数据吗').then(function () {
        _this5.dataList[index].data.splice(row.$index, 1);
      });
    },
    // 修改分组状态
    showCate: function showCate(row) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.cate_id = row.id;
              data = {
                status: row.status === 1 ? 0 : 1
              };
              _context4.next = 4;
              return formCatePutApi(_this6.cate_id, data);
            case 4:
              _context4.next = 6;
              return _this6.getList();
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 保存表单
    submitFrom: function submitFrom() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var result, data;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              result = true;
              if (result) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return", _this7.$message.error('请选择职位'));
            case 3:
              _this7.dataList.forEach(function (item) {
                item.cate_id = item.id;
                item.data.forEach(function (val) {
                  if (!val.key_name || !val.type) {
                    result = false;
                  }
                  _this7.typeOptions.map(function (type) {
                    if (type.value === val.type) {
                      val.input_type = type.type;
                    }
                  });
                });
              });
              if (result) {
                _context5.next = 6;
                break;
              }
              return _context5.abrupt("return", _this7.$message.error('字段名称和字段类型不能为空，请重新输入'));
            case 6:
              data = {
                data: _this7.dataList
              };
              _this7.loading = true;
              formCateSaveDataApi(_this7.activeName, data).then(function (res) {
                if (res.status === 200) {
                  _this7.loading = false;
                } else {
                  _this7.loading = false;
                }
              });
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 保存分组
    submit: function submit(val) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var data;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!_this8.move) {
                _context6.next = 7;
                break;
              }
              // 移动分组弹窗提交
              _this8.cate_id = val.itemId;
              data = {
                id: _this8.id,
                cate_id: _this8.cate_id
              };
              _context6.next = 5;
              return formCateMoveApi(_this8.activeName, data);
            case 5:
              _context6.next = 14;
              break;
            case 7:
              if (!_this8.cate_id) {
                _context6.next = 12;
                break;
              }
              _context6.next = 10;
              return formCatePutSaveApi(_this8.cate_id, val);
            case 10:
              _context6.next = 14;
              break;
            case 12:
              _context6.next = 14;
              return formCateSaveApi(_this8.activeName, val);
            case 14:
              _context6.next = 16;
              return _this8.$refs.oaDialog.handleClose();
            case 16:
              _context6.next = 18;
              return _this8.getList();
            case 18:
              _this8.move = false;
              _this8.cate_id = '';
              _this8.id = '';
              _this8.formDataInit = {};
            case 22:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    // 删除分组
    deleteCate: function deleteCate(id) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this9.$modalSure('确认删除此数据吗');
            case 2:
              _context7.next = 4;
              return formCateDeleteApi(id);
            case 4:
              _context7.next = 6;
              return _this9.getList();
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    // 新增分组
    addGroup: function addGroup() {
      this.addGroupingData();
      this.fromData.title = '新增分组';
      this.fromData.type = 'add';
      this.$refs.oaDialog.openBox();
    },
    // 自动新增行
    addANewLine: function addANewLine(index) {
      var list = {
        key_name: '',
        type: '',
        dictionary: '',
        optionItems: [],
        enable_delete: 1
      };
      this.dataList[index].data.push(list);
    },
    handleClick: function handleClick(tab, event) {
      this.getList();
    },
    // 判断是否是下拉选择
    getTypes: function getTypes(row, type1, type2, type3) {
      var result = this.typeOptions.find(function (item) {
        return row == item.value;
      });
      if (result) {
        return result.type !== type1 && result.type !== type2 && result.type !== type3;
      }
    },
    // 表格拖拽排序
    rowDrop: function rowDrop() {
      var _this10 = this;
      var list = this.$refs.table;
      if (list.length == 0) return;
      list.map(function (item, index) {
        var tbody = item.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
        Sortable.create(tbody, {
          animation: 300,
          onEnd: function onEnd(e) {
            var targetRow = _this10.dataList[index].data.splice(e.oldIndex, 1)[0];
            _this10.dataList[index].data.splice(e.newIndex, 0, targetRow);
            var data = [];
            _this10.dataList[index].data.map(function (item) {
              data.push(item.id);
            });
          }
        });
      });
    }
  }
};